import { useApolloClient } from '@apollo/client';
import { ensureNormalizedCacheObjectClient } from './utils';

export const useApolloTypedClient = () => {
  const apolloClient = useApolloClient();
  const typedClient = ensureNormalizedCacheObjectClient(apolloClient);

  return typedClient;
};
